/**
 * FAQ Audience Tabs Switching
 */
export const initFaqAudienceTabs = () => {
	const tablists = document.querySelectorAll('.faq-audience-tablist');
	tablists.forEach((tablist) => {
		const container = tablist.closest('section');
		if (!container) return;

		const tabs = tablist.querySelectorAll('button');
		const panels = container.querySelectorAll('.faq-audience-panel');

		tabs.forEach((tab) => {
			tab.addEventListener('click', function () {
				const targetId = this.getAttribute('data-target');
				tabs.forEach((t) => {
					t.classList.remove('btn-teal');
					t.classList.add('btn-outline');
					t.setAttribute('aria-selected', 'false');
				});
				this.classList.remove('btn-outline');
				this.classList.add('btn-teal');
				this.setAttribute('aria-selected', 'true');

				panels.forEach((p) => {
					if (p.id === targetId) {
						p.classList.remove('hidden');
						p.classList.add('block');
					} else {
						p.classList.remove('block');
						p.classList.add('hidden');
					}
				});
			});
		});
	});
};

if (typeof document !== 'undefined') {
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initFaqAudienceTabs);
	} else {
		initFaqAudienceTabs();
	}
}

